import styled from "styled-components";

export const RecentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 20px 5px;
  padding: 0px 10px;
  cursor: pointer;
  color: black;
  border-right: 1px dotted black;
  border-right-width: ${({ isFirst }: { isFirst: boolean }) => (isFirst ? "0px" : "1px")};
  border-right-style: dotted;
  border-right-color: black;
  height: 80px;
  width: 200px;
  @media (max-width: 820px) {
    width: 100%;
    height: 100px;
  }
`;

export const RecentWrapperEmpty = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 20px 5px;
  padding: 0px 10px;

  color: black;
  order-right: 1px dotted black;
  border-right-width: ${({ isFirst }: { isFirst: boolean }) => (isFirst ? "0px" : "1px")};
  border-right-style: dotted;
  border-right-color: black;
  height: 80px;
  width: 200px;
  @media (max-width: 820px) {
    width: 100%;
    height: 100px;
  }
`;

export const RecentImageWrapper = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 820px) {
  }
`;

export const RecentImageWrapperEmpty = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.1;

  @media (max-width: 820px) {
  }
`;

export const RecentImg = styled.img`
  width: ${({ gameType }: { gameType: string }) => (gameType === "puzzle" ? "75px" : "90px")};
  height: 75px;
  padding: ${({ gameType }: { gameType: string }) => (gameType === "puzzle" ? "5px" : "0px")};
  object-fit: ${({ gameType }: { gameType: string }) =>
    gameType === "puzzle" ? "contain" : "cover"};

  @media (max-width: 820px) {
    height: 80%;
  }
`;

export const RecentImgEmpty = styled.img`
  width: 70px;
  height: 70px;

  object-fit: contain;
`;

export const MetaWrapper = styled.div`
  width: 100%;
  margin: auto;
  padding-right: 20px;
  display: flex;
  flex-direction: column;
  align-content: center;
`;
export const RecentDes = styled.div`
  color: black;
  font-size: 17.5px;
  font-weight: 600;
  line-height: 18px;
  text-decoration: none;
  @media (max-width: 820px) {
    margin-top: 5px;
  }
`;
export const RecentName = styled.div`
  color: #78787b;
  line-height: 20px;
  font-size: 13px;
  @media (max-width: 820px) {
    margin-top: 0;
  }
`;
